<template>
<div class="chapter">
<div class="inner_page">
<div class="pg-boilerplate" id="pgepubid00002">
<h2 class="sigil_not_in_toc1" id="chII" title="“Hanging is Too Good⸺”">CHAPTER II: “HANGING IS TOO GOOD⸺”</h2>
<p class="calibre11">Pinnacle City was the oldest settlement in the Tumbling River country
and had always been the county seat since the boundary lines had been
drawn. Originally the place had been only a small settlement and the
houses had been built along a wagon-road. And as the place grew larger
this road became the main street, with very little added to the original
width. In several places the road had twisted to avoid a mud-hole, and
the main street was consequently very crooked.</p>
<p class="calibre11">But Pinnacle City had never become a metropolis. It was still the small
cow-town; muddy in winter, dusty in summer, with poorly made wooden
sidewalks. The railroad had added little to Pinnacle City except a
brick-red depot warehouse and some loading corrals.</p>
<p class="calibre11">Eighteen miles southeast was the town of Kelo, and twelve miles
northwest was the town of Ransome. Tumbling River ran southwest, cutting
straight through the centre of the valley. A short distance west of
Pinnacle City were the high pinnacles of the Tumbling range, which gave
the town its name. Barbed-wire had never made its appearance in the
Tumbling River range, feed was good and there was plenty of water.</p>
<p class="calibre11">Five outfits ranged their stock in the Pinnacle City end of the Tumbling
River range, the farthest away from town being Ed Merrick’s Circle M,
located about eight miles due south. Midway between the town and the
Circle M, and just on the east bank of Tumbling River, was Jim Wheeler’s
HJ ranch.</p>
<p class="calibre11">Southwest, about three miles from town, was Curt Bellew’s Lazy B. This
was on the west side of the river. A little less than three miles to the
northeast of Pinnacle City was Uncle Hozie Wheeler’s Flying H; and four
miles northwest of town was Buck West’s 3W3 outfit.</p>
<p class="calibre11">Jim Wheeler’s ranch was just between the wagon road and the railroad, on
the way to Kelo. The two bridges were less than half a mile apart. Jim
Wheeler’s wife had died when Peggy was a little slip of a girl but Jim
had kept his ranch and raised his daughter, aided and abetted by Aunt
Emma Wheeler, who had wanted to raise her. The HJ was a small ranch. Jim
had been content to run a few cattle and horses. Wong Lee, the Chinese
cook, had been with the HJ for years, and Jim swore that the county had
always assessed Wong as personal property of the HJ.</p>
<p class="calibre11">Uncle Hozie Wheeler’s Flying H was a larger outfit, employing three
cowboys, Lonnie Myers, Dan Leach and “Nebrasky” Jones, known as the
“Heavenly Triplets,” possibly because there was nothing heavenly about
any of them. Lonnie was a loud-talking boy from the Milk River country;
Dan Leach hailed from eastern Oregon, and Nebrasky’s cognomen disclosed
the State of his nativity. Uncle Hozie called them his debating society
and entered into their State arguments in favour of Arizona.</p>
<p class="calibre11">Curt Bellew’s Lazy B supported three cowboys: Eph Harper, “Slim” Coleman
and Honey Bee. Mrs. Bellew contended that the ranch could be handled
with one man, but that Curt wanted to match Hozie Wheeler in numbers.
She pointed out the fact that Buck West could run his 3W3 outfit with
only two men, Jimmy Black and Abe Liston, just because Buck wasn’t so
lazy he couldn’t do some of the work himself. Which of course was a
gentle hint that Curt might do more, himself.</p>
<p class="calibre11">The Circle M ranged more stock than any of the other ranches and only
carried three men besides Ed Merrick. Ben Collins, “Dutch” Siebert and
Jack Ralston made up the personnel of the Circle M, since Len Kelsey had
left them to take up his duties as deputy sheriff under Joe Rich.</p>
<p class="calibre11">It was the morning following the wedding which had not taken place that
Joe Rich rode up to the Flying H. All night long he had ridden across
the hills, fighting out with himself to decide what to do, and he was a
sorry-looking young man when he drew rein near the veranda of the Flying
H ranch-house. He had ridden away without coat, hat or chaps. His
trouser-legs were torn from riding past brush, his face scratched, his
hair dishevelled.</p>
<p class="calibre11">Uncle Hozie saw him from the window and came down to him. Lonnie Myers
and Nebrasky were at the corral, saddling their horses. They merely
glanced in his direction, recognising him, but paying no attention.
Uncle Hozie looked Joe over critically, but said nothing.</p>
<p class="calibre11">“Well, why don’t yuh say somethin’?” demanded Joe wearily. “My God,
Hozie, don’t just stand there! Swear at me, if yuh feel thataway.”</p>
<p class="calibre11">Uncle Hozie shook his head slowly and sighed. He had drunk a little too
much the night before and his spirits were not overly bright. A tin can
rattled loudly, and they looked toward the stable, where Dan Leach was
throwing out the stuff they had stacked in the stall for the shivaree.</p>
<p class="calibre11">Joe’s eyes closed tightly for a moment and he turned his head away. He
knew what those noise producers had been meant for. A cow-bell clattered
among the cans. Lonnie and Nebrasky were watching Joe from the corral.</p>
<p class="calibre11">“I don’t feel like cussin’ anybody,” said Uncle Hozie.</p>
<p class="calibre11">“Not even me?” asked Joe.</p>
<p class="calibre11">“You? Nope. What’sa use, Joe? If yuh cuss folks before they do wrong it
might do some good. Afterward, it’s no use. Yuh can’t wipe out what a
man writes in the book of fate, Joe.”</p>
<p class="calibre11">“And I shore wrote a page last night, Hozie.”</p>
<p class="calibre11">“Yea-a-ah, I’d tell a man yuh did, Joe.” Uncle Hozie cocked one eye and
looked at Joe.</p>
<p class="calibre11">“There’s, by actual count, seventeen blasted fools in this Tumblin’
River range—and yo’re all of ’em, Joe.”</p>
<p class="calibre11">“I admit it, Hozie.”</p>
<p class="calibre11">“You do? My God, you didn’t think for a minute yuh could deny it, didja?
Huh! Why don’tcha git down? My God, I hate to talk to a man on a horse!
Especially the mornin’ after. Kinda hurts my eyes to look up.”</p>
<p class="calibre11">Joe shook his head.</p>
<p class="calibre11">“No, I can’t stay, Hozie.”</p>
<p class="calibre11">“Nobody asked yuh to, did they?”</p>
<p class="calibre11">“No. Is Peggy here yet?”</p>
<p class="calibre11">“No, she ain’t, Joe,” softly. “They went home last night—her and Jim
and Laura Hatton. Jim thought it was best. Emma tried to get ’em to stay
a while, but they kinda wanted to be at home, where there wouldn’t be
anybody to ask questions.”</p>
<p class="calibre11">“To ask questions!” echoed Joe. “That’s the worst of it.”</p>
<p class="calibre11">“I dunno,” sighed Hozie. “It’s the first weddin’ I ever seen that
ravelled right out thataway. Honey Bee showed up with his coat in one
hand and his shoes in the other. He shore was the worst-lookin’ best man
I ever seen.”</p>
<p class="calibre11">“Poor old Honey.”</p>
<p class="calibre11">“Yeah, yuh ought to feel sorry for somebody, Joe. I don’t sabe yuh; by
Gee, I don’t! I thought I knew yuh, but I reckon I don’t. I ain’t said
what I think about yuh to anybody. Mebbe I ain’t had no chance; so many
folks has said what they thought about it that I’ve kinda got their
ideas and mine all tangled up. Mebbe after a while I’ll git my own ideas
straightened up to where I know they’re all mine, I’ll look ’em over.”</p>
<p class="calibre11">“I suppose they’d like to hang me, Hozie.”</p>
<p class="calibre11">“Hang yuh? Huh! Reminds me of a Dutchman I knowed. He runs into a gang
of punchers that was goin’ to lynch a horse thief. Dutchy runs into ’em,
and asks what it’s all about.</p>
<p class="calibre11">“‘Vat iss it all about?’ asks Dutchy.</p>
<p class="calibre11">“‘Goin’ to hang a horse thief,’ says a puncher.</p>
<p class="calibre11">“‘Oh, dot’s too bad,’ says Dutchy. ‘You shouldn’t hang a man for
stealing von horse.’</p>
<p class="calibre11">“‘It was yore horse, Dutchy.’</p>
<p class="calibre11">“‘So-o-o-o? Don’t hang him; dot’s too good for him. Let me kick him in
de pants.’”</p>
<p class="calibre11">Joe smiled bitterly.</p>
<p class="calibre11">“Do you think hangin’ is too good for me, Hozie?” he asked.</p>
<p class="calibre11">“I don’t say it is, Joe; but when I got a look at Peggy last night I
shore wanted to give yuh some of the Dutchman’s medicine.”</p>
<p class="calibre11">Joe wiped the back of his hand across his cheek and wet his lips with a
dry tongue.</p>
<p class="calibre11">“I reckon I’m all through in Tumblin’ River, Hozie.”</p>
<p class="calibre11">“Well,” Uncle Hozie bit off a huge chew of tobacco and masticated
rapidly, thoughtfully. “Well, Joe, it ain’t for me to say. I got up as
far as ‘Silver Threads’ last night myself, but of course it wasn’t my
weddin’ night. But, accordin’ to some remarks I heard expressed last
night, the folks of the Tumblin’ River ain’t takin’ up no collection to
buy yuh a monument. Yuh see, Joe, Peggy is kinda well liked.’”</p>
<p class="calibre11">“Kinda well liked! My Lor’!” Joe shut his jaw tightly and fumbled at his
reins. “I’ll be goin’, Hozie.”</p>
<p class="calibre11">“Yeah? Well.” Hozie spat thoughtfully, but did not look up at Joe.</p>
<p class="calibre11">“Be good to yourself,” he said slowly.</p>
<p class="calibre11">Joe turned and rode away, never looking back. Hozie sat down on the
veranda and Aunt Emma came out. She had been watching from a window.</p>
<p class="calibre11">“What did he have to say?” she asked.</p>
<p class="calibre11">“Joe? Oh, nothin’ much.”</p>
<p class="calibre11">“What excuse did he offer?”</p>
<p class="calibre11">“None.”</p>
<p class="calibre11">“Didn’t deny bein’ drunk?”</p>
<p class="calibre11">“Didn’t mention it.”</p>
<p class="calibre11">“Feel sorry about it, Hozie?”</p>
<p class="calibre11">“Didn’t say.”</p>
<p class="calibre11">“Well, what in the world did you two talk about?”</p>
<p class="calibre11">“Public opinion.”</p>
<p class="calibre11">Aunt Emma snorted.</p>
<p class="calibre11">“Public opinion, eh? Did you tell him what you thought of him?”</p>
<p class="calibre11">“Nope; wasn’t quite clear in my own mind, Emma.”</p>
<p class="calibre11">“I suppose not. If Jim hadn’t stopped yuh last night⸺”</p>
<p class="calibre11">“Oh, I know,” Hozie smiled softly. “My voice was kinda good, too. Curt
Bellew said he never heard me sing so well.”</p>
<p class="calibre11">“Curt was drunk, too.”</p>
<p class="calibre11">“Thasso. Prob’ly accounts for him likin’ my voice. I’d like to sing to a
sober man some day and get an honest opinion.”</p>
<p class="calibre11">“No sober man would listen to you, Hozie.”</p>
<p class="calibre11">“I s’pose not,” Uncle Hozie sighed deeply. “I suppose it’s jist sort of
a drunken bond between inebriates that makes me feel sorry for Joe Rich,
Emma; but I do. He looked so doggone helpless and lonesome this mornin’.
No, I didn’t tell him I felt sorry. He don’t deserve sympathy.”</p>
<p class="calibre11">“He don’t deserve anythin’,” declared Aunt Emma.</p>
<p class="calibre11">“Hangin’—mebbe.”</p>
<p class="calibre11">“And you feel sorry for him?”</p>
<p class="calibre11">“I want to, Emma.” Uncle Hozie turned and looked at her. “I’ve worked
with that boy a lot. Me and him have rubbed knees on some hard rides,
and I kinda looked on Joe like I would on my own son. He was straight
and square—until now, Emma. Mebbe,” he hesitated for a moment, “mebbe
I’m feelin’ sorry for the Joe Rich of yesterday.”</p>
<p class="calibre11">“Well, that’s different, Hozie,” said Aunt Emma softly, and went back in
the house. She had thought a lot of Joe Rich of yesterday, too.</p>
<p class="calibre11">Joe rode back to Pinnacle City and stabled his tired horse. He had spent
all his savings for a little four-room house on the outskirts of
Pinnacle and had gone in debt for the furnishings. It was to have been
their home.</p>
<p class="calibre11">Len Kelsey was asleep in the office when Joe came in and sat down at his
desk. He woke up and looked curiously at Joe.</p>
<p class="calibre11">“Wondered where yuh was, Joe,” he said sleepily.</p>
<p class="calibre11">“Yeah?”</p>
<p class="calibre11">Joe drew out a sheet of paper, dipped a pen in the ink bottle and began
writing. Kelsey turned over and went to sleep again.</p>
<p class="calibre11">Joe finished writing, folded the paper and walked out of the office.
Just south of his office was the old two-story frame-building
court-house, and as Joe started to enter the front door he met Jim
Wheeler and Angus McLaren, chairman of the board of county
commissioners.</p>
<p class="calibre11">McLaren was a big, raw-boned Scot who owned a general store in Kelo.
McLaren, Ed Merrick and Ross Layton, of Ransome, composed the board of
commissioners.</p>
<p class="calibre11">Joe Rich stopped short as he faced Jim Wheeler. For possibly five
seconds the HJ cattleman stared at the sheriff of Tumbling River, and
then, without a word, he struck Joe square in the face, knocking him
through the doorway, where Joe went to his haunches on the sidewalk,
dazed, bleeding from his nose and mouth.</p>
<p class="calibre11">Quickly the big Scotsman stepped in front of Wheeler, grasping him with
both hands.</p>
<p class="calibre11">“Stop it, Jim!” he ordered.</p>
<p class="calibre11">Wheeler stepped back, his face crimson with anger, but saying nothing.</p>
<p class="calibre11">Joe did not get up, nor did he even look at Wheeler, who stepped past
McLaren and went slowly up the street.</p>
<p class="calibre11">“Are ye much hurt, Joe?” asked McLaren not unkindly. He knew all about
what had happened the night before.</p>
<p class="calibre11">Joe did not reply. He got slowly to his feet and leaned against the
building, while he drew out the folded sheet of paper. Then he unpinned
the silver star from the bosom of his soiled shirt, pinned it to the
sheet of paper and handed it to McLaren. Then he turned and went slowly
down the street.</p>
<p class="calibre11">McLaren stared after him. Joe Rich staggered slightly, but he was not
drunk. McLaren unfolded the paper and read it carefully. It was Joe’s
resignation, written to the board of county commissioners. McLaren put
it in his pocket.</p>
<p class="calibre11">“Life’s queer,” said the big Scot thoughtfully. “Yesterday he was Joe
Rich, sheriff of Tumblin’ River, the luckiest young man in the world.
And today—nobody! Ye never know yer luck, so ye don’t; and who has the
right to judge him?”</p>
<p class="calibre11">He turned and went back to his office.</p>
<p class="calibre11">Joe staggered off the main street and went down through an alley. He
wanted to get off the street; to be where no one would talk to him.
Strangely enough, he felt no pain from the blow. Except for the fact
that his face was bleeding, he was not aware he had been hurt.</p>
<p class="calibre11">The thought of Jim Wheeler knocking him down hurt worse than any blow,
and he moved along blindly; not going anywhere—just away from
everybody. He did not realise where he was until he heard a voice speak
his name.</p>
<p class="calibre11">He was standing beside a picket-fence, and there was Honey Bee, holding
the reins of his horse. The picket-fence was the one around Joe’s house;
the one Aunt Emma had called “Honeymoon Home.”</p>
<p class="calibre11">“I seen yuh cuttin’ across this way,” explained Honey. “You shore got an
awful lookin’ face on yuh, cowboy. Horse kick yuh?”</p>
<p class="calibre11">Joe shook his head. He didn’t want to talk with Honey Bee, but he knew
there was no chance of getting away from him. Honey was tying his horse
to the fence, and now he came over to Joe.</p>
<p class="calibre11">“Mebbe we better go in the house, Joe,” he said. “Yuh got to wash off
that blood.”</p>
<p class="calibre11">Joe nodded and followed Honey to the house. It was not locked. Folks did
not lock their houses in the Tumbling River country. Honey filled a
basin with water and found a towel. Honey was rather rough but
effective.</p>
<p class="calibre11">“Yo’re a hell of a lookin’ thing,” he declared.</p>
<p class="calibre11">“Thasall right,” mumbled Joe. “Thanks, Honey.”</p>
<p class="calibre11">Joe slumped back in a rocking-chair and closed his eyes, while Honey put
away the basin and towel.</p>
<p class="calibre11">“I’m wonderin’ what the other feller looks like,” said Honey, as he
manufactured a cigarette.</p>
<p class="calibre11">“Jim Wheeler,” said Joe.</p>
<p class="calibre11">“The devil! Did Jim Wheeler hit yuh, Joe?”</p>
<p class="calibre11">“Yeah.”</p>
<p class="calibre11">“Well, I’ll be bust! Jim Wheeler! What did he say, Joe?”</p>
<p class="calibre11">“Nothin’. Wasn’t anythin’ to be said.”</p>
<p class="calibre11">“Uh-huh. Makes it kinda hard for yuh, cowboy. Anyway, yuh had to meet
him sooner or later. Ain’tcha goin’ out to see Peggy?”</p>
<p class="calibre11">“No, I can’t do that, Honey.”</p>
<p class="calibre11">“I s’pose not. I was past there today—this mornin’. Saw Laura. Didn’t
sleep none, I reckon. She’s a darned pretty girl, but this mornin’ her
eyes shore looked like two burned holes in a blanket. I pulled off an
awful fox pass last night. I took off my coat and shoes, ’cause I shore
was in misery, and then Laura comes hoppin’ in on me. I has to make my
little bow, and my belt missed connections with my pants. Na-a-aw, I
saved myself, all right; but it shore needed quick action. Either that
tailor is awful cock-eyed, or I’m a queer built jigger.”</p>
<p class="calibre11">“You didn’t see Peggy?” asked Joe softly.</p>
<p class="calibre11">“Nope. I asked Laura how she was, and Laura asks me how any other girl
would be under them conditions. If I was you, I’d go out and have a talk
with her. But not the way yuh look now, Joe. Rest up a while. Let Len
Kelsey run the office for a few days.”</p>
<p class="calibre11">“I resigned this mornin’, Honey.”</p>
<p class="calibre11">“Yuh resigned? Yuh mean you’ve quit bein’ sheriff? Aw, blazes, why didja
do that? You idjit! Throwin’ up a job like that. Ho-o-o-o—hum-m-m-m!
Joe, yo’re a fool.”</p>
<p class="calibre11">“In every way, Honey.”</p>
<p class="calibre11">“A-a-aw, I didn’t mean it thataway, Joe. You know me. I’d go to hell and
half-way back for you, and you know it. But you’ve shore dug yourself an
awful hole, and you’ll never git out by quittin’ thataway. Laura is
tryin’ to get Peggy to go home with her for a while. She’ll prob’ly have
one awful time convincin’ Jim Wheeler that it’s the best thing for Peggy
to do—but Laura is shore convincin’.”</p>
<p class="calibre11">“You mean that Peggy would go East, Honey?”</p>
<p class="calibre11">“Yeah, sure. She’s got friends back there; folks she knew where she went
to school with Laura. Mebbe it’s the best thing for her to do. Jim ain’t
got a lot of money, but he can afford it I reckon. What do you figure on
doin’, Joe?”</p>
<p class="calibre11">“Oh, I don’t know, Honey. I can’t make up my mind to anythin’. I just
run in circles, and every way I turn there’s a blank wall; no way out.”</p>
<p class="calibre11">“Yeah, I s’pose so. Let’s go and buy a drink.”</p>
<p class="calibre11">Joe shook his head.</p>
<p class="calibre11">“I don’t think I’ll ever want another drink of liquor, Honey. I’m goin’
to sleep a while, and mebbe I can think my way clear.”</p>
<p class="calibre11">Honey came past the court-house and saw Jim Wheeler, Angus McLaren, Ed
Merrick and Ross Layton just going into the place. They were going to
consider the resignation of Joe Rich, and it did not take them long to
decide on an acceptance.</p>
<p class="calibre11">Ross Layton was a saloon owner in Ransome. He was rather small, slightly
gray, and affected flowing ties and fancy vests. The rest of his raiment
was rather sombre, a fact which had caused Honey Bee to remark—</p>
<p class="calibre11">“Looks like a bleedin’ bouquet of flowers wrapped up in crêpe.”</p>
<p class="calibre11">There was no argument over the appointment of Len Kelsey as the
successor of Joe Rich, and it was up to Len to pick his own deputy. They
went from the court-house to the sheriff’s office, where they told Len
of his good fortune. The skinny-faced deputy grinned widely and accepted
his honours. As the three men were leaving Len said to Merrick—</p>
<p class="calibre11">“Send Jack in to see me, Ed.”</p>
<p class="calibre11">“All right, Len,” nodded Merrick.</p>
<p class="calibre11">Len and Jack Ralston had been bunkies at the Circle M, and it would be
the natural thing for Len to appoint Jack as his deputy.</p>
<p class="calibre11">McLaren had some business to attend to at the Pinnacle City bank, so he
left Merrick and Wheeler together. Layton had left them at the sheriff’s
office.</p>
<p class="calibre11">“It’s sure funny how things change,” observed Merrick.</p>
<p class="calibre11">The owner of the Circle M was slightly under forty years of age, above
medium height. He was rather good-looking and dressed well. However, he
looked more like a gambler than a county official and a solid citizen.
Perhaps this aspect was enhanced by the fact that he shaved regularly,
kept his black moustache trimmed and waxed to needle-like points, and
wore pants instead of overalls.</p>
<p class="calibre11">“I was thinkin’ about Joe Rich,” said Merrick.</p>
<p class="calibre11">Jim Wheeler shoved his hands deep in his pockets and did not lift his
eyes from serious contemplation of his own boot-toes.</p>
<p class="calibre11">“I wanted to talk to yuh, Merrick,” he said slowly. “This sure has been
a blow to me. Laura Hatton wants Peggy to go home with her. I
dunno—mebbe’s it’s the best thing to do. I don’t mind layin’ my cards
on the table.”</p>
<p class="calibre11">Jim Wheeler looked up at Merrick.</p>
<p class="calibre11">“I owe the Pinnacle City bank seven thousand dollars and I can’t ask ’em
for any more, Merrick.”</p>
<p class="calibre11">“Uh-huh.” Merrick did not seem impressed.</p>
<p class="calibre11">“You know what the HJ ranch is, Merrick. Seven thousand is a lot of
money against it. I’ve got to have another thousand, if I send Peggy
back with Laura.”</p>
<p class="calibre11">“Well, I might let yuh have it, Jim. Bank got a mortgage?”</p>
<p class="calibre11">“Yeah.”</p>
<p class="calibre11">“Well, I’ll take your note. How soon do yuh need it?”</p>
<p class="calibre11">“Any time in the next couple of days.”</p>
<p class="calibre11">“All right, I’ll let yuh have it, Jim.”</p>
<p class="calibre11">They separated and Merrick went to the Pinnacle Saloon, where he met
Honey Bee. Honey had drunk enough to make him loquacious.</p>
<p class="calibre11">“Didja accept Joe’s resignation?” asked Honey.</p>
<p class="calibre11">“Nothing else to do,” replied Merrick. There was little love lost
between these two men.</p>
<p class="calibre11">“Uh-huh.” Honey leaned against the bar and cuffed his hat to one side of
his head.</p>
<p class="calibre11">“Who’sa sheriff now?”</p>
<p class="calibre11">“Len Kelsey.”</p>
<p class="calibre11">“O-o-o-oh, is that so? My, my! Things shore do change quick. If yuh had
a lawyer and a doctor in yore Circle M, you’d kinda run the whole danged
country, wouldn’t yuh?”</p>
<p class="calibre11">“Oh, I don’t know,” Merrick grinned and invited Honey to have a drink.</p>
<p class="calibre11">“Well, I’ll drink with yuh,” agreed Honey. “I’m sad at heart.” They
lifted their glasses to each other.</p>
<p class="calibre11">“Hits Jim Wheeler pretty hard,” said Merrick gravely.</p>
<p class="calibre11">“Sure does. Here’s how.”</p>
<p class="calibre11">“He tells me,” said Merrick, placing his glass on the bar, “that his
daughter is goin’ East with Miss Hatton.”</p>
<p class="calibre11">“Yeah, I heard that,” said Honey sadly. “I didn’t know it was all
settled.”</p>
<p class="calibre11">“I reckon it is. Anyway, I’m makin’ a loan to Jim. He’s in kinda heavy
at the bank; so I’m lettin’ him have the money.”</p>
<p class="calibre11">“Uh-huh. Well, that’s nice of yuh.”</p>
<p class="calibre11">“Where’s Joe Rich, Honey?”</p>
<p class="calibre11">“I left him down at his new place, settin’ there, lookin’ at nothin’.
That boy’s half crazy.”</p>
<p class="calibre11">“Must have been more than half crazy,” declared Merrick.</p>
<p class="calibre11">“Yeah. Now I’ll buy a drink.”</p>
<p class="calibre11">Honey went back to Joe’s place before he went to the Lazy B, and found
Joe still sitting in the same chair. He told Joe what Merrick had said
about Jim’s borrowing money from Merrick to send Peggy with Laura.</p>
<p class="calibre11">“How much did he have to borrow?” asked Joe.</p>
<p class="calibre11">Honey didn’t know.</p>
<p class="calibre11">“Jim Wheeler must be short of money,” said Honey. “Merrick said he was
in pretty deep with the Pinnacle bank. They accepted yore resignation
and appointed Len Kelsey, Joe.”</p>
<p class="calibre11">“Quick work,” said Joe shortly.</p>
<p class="calibre11">“Yeah, I’ll say it is. You were a fool to quit that job.”</p>
<p class="calibre11">Honey left him there and rode out of town. He intended going straight
back to the Lazy B, but began thinking about Laura Hatton so strongly
that he found himself crossing the Tumbling River bridge before he
realised where he was heading.</p>
<p class="calibre11">Jim Wheeler arrived there ahead of Honey, and was sitting on the porch,
talking with Peggy and Laura, while Jack Ralston, of the Circle M, sat
on a step, hat on the back of his head. Ralston was a tall, curly-headed
young man who thought quite a lot of Jack Ralston. He was a clever
roper, and one of the best bronc riders in the country.</p>
<p class="calibre11">Honey scowled and wanted to keep right on riding, but he was so close
that it might look queer if he didn’t stop. Peggy went into the house
before Honey arrived. Ralston looked critically at Honey, nodded
shortly, and resumed conversation with Laura.</p>
<p class="calibre11">Honey dismounted. Then he uncinched his saddle, shook it a little, and
took plenty of time cinching it again. He knew he was of a hair-trigger
disposition, and was trying to curb it. Ralston was telling Laura about
how he rode Derelict, a locally famous outlaw horse, at a recent rodeo.
Honey’s ears reddened slightly. Derelict had thrown Honey the day before
Ralston had ridden him, and it had taken ten minutes for Honey to
recover consciousness.</p>
<p class="calibre11">“It must be wonderful to ride a bucking horse,” said Laura. “I saw
Lonnie Myers ride one at the Flying H. Oh, it was a lot of fun!”</p>
<p class="calibre11">“That was just an ordinary bucker,” said Ralston. “Any puncher can ride
a half-broke bucker. Lots of the boys in this country think they’re
riders, but when it comes to fannin’ the real buckers—they don’t show
much. You wait until we have another rodeo, and I’ll show yuh some
ridin’.”</p>
<p class="calibre11">“Yeah, he’s a good rider,” said Honey, still fussing with his latigo.
“Awful good rider. I shouldn’t be surprised if he’s half as good as he
thinks he is. Ridin’ broncs makes folks talk thataway. Of course, us
ord’nary punchers don’t go lookin’ for glory in the bronc corral, so we
never do get shook up very bad. But you can tell them good riders every
time. They’re kinda buck-drunk, as yuh might say. They ain’t very
tight-brained to begin with, and all that shock and jerk soon gits the
inside of their heads kinda rattly.</p>
<p class="calibre11">“Oh, they’re all right, as far as that goes. Nobody expects ’em to do
anythin’ but ride buckers. But they don’t know it, and the way them
p’fessional bronc riders do talk! Mebbe they ain’t so much to blame, at
that; but everythin’ is ‘I’ with ’em. Rodeos are all right, I s’pose.
Folks get a lot of fun out of it; but them buckin’ contests shore do
bring in undesirable citizens.”</p>
<p class="calibre11">Honey had spoken so earnestly that Laura Hatton did not realise he was
talking about Jack Ralston.</p>
<p class="calibre11">But Jack Ralston knew. He got to his feet, glaring at Honey, who paid no
attention to him at all. He adjusted the split-ear headstall of his
bridle, looked it over critically and came over to the steps. Ralston
glanced from Honey to Laura and then shot a glance at Jim Wheeler, who,
in spite of the misery in his soul, was trying to stifle a laugh.</p>
<p class="calibre11">“Well, I’ll be goin’,” said Ralston. “Good day.”</p>
<p class="calibre11">Honey twisted his mouth into a wide grin as he watched Ralston ride
away.</p>
<p class="calibre11">“He is very entertaining,” said Laura.</p>
<p class="calibre11">“Who—Jack?” Honey grinned widely. “Liars mostly always are.”</p>
<p class="calibre11">Jim Wheeler laughed and went into the house, for which Honey thanked him
mentally. Honey sat down on the steps, cuffed his hat to the back of his
head and sighed deeply.</p>
<p class="calibre11">“How’s Peggy feelin’?” he asked.</p>
<p class="calibre11">“Better. She’s going back home with me; it’s all settled.”</p>
<p class="calibre11">“Uh-huh,” said Honey gloomily. “Lotta luck in that for me.”</p>
<p class="calibre11">“For you?”</p>
<p class="calibre11">“Yeah; you goin’ away.”</p>
<p class="calibre11">“Oh!” Laura’s blue eyes opened wide. “Well, you knew I was only here on
a visit, Honey.”</p>
<p class="calibre11">“Oh! shore; I knowed it. Yuh can’t stay, huh?”</p>
<p class="calibre11">“Not very well.”</p>
<p class="calibre11">“Uh-huh. I s’pose—” Honey hesitated awkwardly. “I s’pose you’ve got a
lot of fellers back East, eh?”</p>
<p class="calibre11">He pointed north, but the direction made no difference. Laura smiled.</p>
<p class="calibre11">“Fellows? A few—perhaps.”</p>
<p class="calibre11">“Uh-huh.” Honey scuffed a heel against the step, rattling his
spur-chain. “I s’pose you’ll be gettin’ married, huh?”</p>
<p class="calibre11">“When?”</p>
<p class="calibre11">“Oh, some of these days,” gloomily.</p>
<p class="calibre11">Laura shook her pretty head violently. “You bet I won’t! After what
happened last night I wouldn’t marry the best man on earth.”</p>
<p class="calibre11">“I’m shore glad to hear yuh say that,” said Honey seriously.</p>
<p class="calibre11">“Why?” demanded Laura quickly.</p>
<p class="calibre11">“’Cause if yuh marry the man I hope yuh will, yuh shore won’t be gettin’
the best man in the world.”</p>
<p class="calibre11">Laura blushed and got to her feet. Honey got up, too, and they faced
each other.</p>
<p class="calibre11">“You ain’t sore, are yuh, Laura?” he asked.</p>
<p class="calibre11">She shook her head slowly.</p>
<p class="calibre11">“No, Honey; I can’t get mad at you—but I do think you are awfully
funny.”</p>
<p class="calibre11">She turned and walked into the house. Honey stared at the doorway for
several moments before going back to his horse.</p>
<p class="calibre11">“She thinks I’m awfully funny,” he told his horse. “I must be—she
didn’t even crack a smile.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section003.vue?66e56a22